export const BUSINESS_UNIT_CUSTOM_TYPE = 'bu-custom-type';
export const BUSINESS_UNIT_CUSTOM_FILEDS = {
  BUDGET: 'budget',
  WORKFLOWS: 'workflows',
};
